<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Pagination,
  Select,
  TableColumn,
  Table,
  Input,
  Tag
} from 'element-ui';
import { tableFun } from '@/utils/tableHeader';
import perMixin from '@/utils/perMixin';

export default {
  mixins: [perMixin],
  components: {
    ElPagination: Pagination,
    ElTableColumn: TableColumn,
    ElTable: Table,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu,
    ElTag: Tag
  },
  props: {
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    paginConfig: {
      type: Object,
      default: () => ({
        background: true
      })
    },
    tableHeader: {
      type: Array,
      required: true
    },
    getTableData: {
      type: Function,
      default: () => () => ({})
    },
    searchFormData: {
      type: Object,
      default: () => ({})
    },
    statusAction: {
      type: Array,
      default: () => []
    },
    saveAction: {
      type: Function,
      default: () => () => ({})
    },
    isShowOnly: {
      type: Boolean,
      default: () => false
    },
    maxHeightDiff: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      nativeSearchFormData: {}, // 内部独立维护的搜索条件，不跟外部合并（header_slot）
      nativeTableConfig: {
        data: [],
        emptyText: '.',
        stripe: true
      },
      loading: false,
      navtiveTableHeader: [],
      nativePaginConfig: {
        page_no: 1,
        page_size: 20, // 初始显示条目
        total: 0
      },
      nativeSort: [],
      formData: {},
      editIndex: -1,
      editRowObj: {},
      editStyle: {},
      editItem: {},
      reSet: false,
      editEvent: null,
      spanIndex: [0],
      pageSize: 10, // 分页初始值
      id: `lyTable${new Date().getTime()}`,
      oldVal: {} // searchFormData oldVal,
    };
  },
  beforeMount() {
    this.initHeader();
    this.editEvent = () => {
      if (this.editIndex >= 0 && this.editItem.editOptions.type === 'text') {
        // input编辑自动保存
        this.saveEdit();
      }
    };
    document.addEventListener('click', this.editEvent);
  },
  beforeDestroy() {
    if (this.editEvent) document.removeEventListener('click', this.editEvent);
  },
  watch: {
    tableHeader() {
      this.initHeader();
    },
    tableConfig() {
      this.initHeader();
    },
    paginConfig() {
      this.initHeader();
    },
    searchFormData: {
      handler(val, oldVal) {
        Object.keys(val).forEach(key => {
          // 内部任何值的变化都将重置为第一页, 浅比较（复杂对象请在外部自行控制）
          if (val[key] !== oldVal[key] || val[key] !== this.oldVal[key]) this.reSet = true;
        });
        // 外部使用v-model时有bug，oldVal手动维护
        if (val) this.oldVal = JSON.parse(JSON.stringify(val));
      },
      deep: true
    },
    term() {
      this.nativePaginConfig.page_no = 1;
      this.setData();
    },
    year() {
      this.nativePaginConfig.page_no = 1;
      this.setData();
    },
    classType() {
      this.nativePaginConfig.page_no = 1;
      this.setData();
    }
  },
  computed: {
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    },
    classType() {
      return this.$store.state.schoolYear.classType;
    },
    isShow() {
      return this.$store.state.schoolYear.isShow;
    }
  },
  methods: {
    toggleRowSelection(row, selected) {
      this.$refs.lyTable.toggleRowSelection(row, selected);
    },
    clearSelection() {
      this.$refs.lyTable.clearSelection();
    },
    initHeader() {
      this.nativeTableConfig = Object.assign({}, this.nativeTableConfig, window.cloneDeep(this.tableConfig));
      this.nativePaginConfig = Object.assign({}, this.nativePaginConfig, window.cloneDeep(this.paginConfig));
      this.pageSize = this.paginConfig.page_size || 10;
      if (this.paginConfig.def_page_size) this.nativePaginConfig.page_size = this.paginConfig.def_page_size;
      if (this.tableHeader.length && typeof this.tableHeader[0] === 'string') {
        this.navtiveTableHeader = tableFun(this.tableHeader);
      } else {
        this.navtiveTableHeader = this.tableHeader;
      }
      if (this.tableConfig && typeof this.tableConfig.data !== 'undefined') {
        this.nativeTableConfig.emptyText = '暂无数据';
        this.setMaxHeight();
      }
    },
    setData() {
      this.loading = true;
      // 更改props后立即调用时获取不到searchFormData实时数据
      this.$nextTick(async () => {
        // 任何条件检索的变化都重置page_no
        if (this.reSet) this.nativePaginConfig.page_no = 1;
        // 外部传入data静态数据时不走请求
        if (this.tableConfig && typeof this.tableConfig.data !== 'undefined') {
          this.loading = false;
          this.setMaxHeight();
          this.nativeTableConfig.emptyText = '暂无数据';
          return;
        }
        const schoolYear = this.isShow
          ? { term: this.term > 0 ? this.term : '', year: this.year > 0 ? this.year : '', class_type: this.classType > 0 ? this.classType : '' }
          : {};
        const params = {
          ...schoolYear,
          ...this.nativeSearchFormData,
          ...this.searchFormData
        };
        const { page_no, page_size } = this.nativePaginConfig;

        // 清除空值和-1(头部检索的时候全部的value值为-1)的值

        Object.keys(params).map(key => {
          if (params[key] === '' || params[key] === -1) {
            delete params[key];
          }
          return key;
        });
        const requestParams = {
          ...params,
          page_no,
          page_size
        };
        const res = await this.getTableData(requestParams);
        if (res && res.data) {
          const { list, total } = res.data;
          if (list) {
            this.nativeTableConfig.data = list;
            this.nativePaginConfig.total = total;
            // 接口没有返回分页数据时默认不分页
            if (!res.data.page_size) this.nativePaginConfig.isHide = true;
            this.$emit('dataChange', { total });
            this.$emit('dataSourceChange', { data: list, total, ...requestParams });
            this.setMaxHeight();
          }
        }
        this.nativeTableConfig.emptyText = '暂无数据';
        this.loading = false;
      });
    },
    clearData() {
      this.nativeTableConfig.data = [];
      this.nativeTableConfig.total = 0;
      this.nativePaginConfig.page_no = 1;
    },
    setMaxHeight() {
      // 要求中间滚动分页固定
      const table = document.getElementById(this.id);
      if (!table) return;
      const el = table.querySelector('.el-table');
      const body = el.querySelector('.el-table__body-wrapper');
      if (!el || !body) return;
      el.style.maxHeight = 'none';
      body.style.maxHeight = 'none';
      setTimeout(() => {
        if (this.$refs.lyTableContent && this.nativeTableConfig.data.length) {
          const position = table.getBoundingClientRect();
          const bodyHeight = document.body.offsetHeight - position.top - 70; // 90是底部分页高度
          let maxHeight = bodyHeight < position.height ? bodyHeight : position.height;
          maxHeight = maxHeight > 200 ? maxHeight : 'none'; // 容错
          const hd = el.querySelector('.el-table__header-wrapper');
          el.style.maxHeight = `${maxHeight + this.maxHeightDiff}px`;
          body.style.maxHeight = `${maxHeight - hd.clientHeight + this.maxHeightDiff}px`;
        }
      }, 500);
    },
    indexMethod(index) {
      if (this.tableConfig && this.tableConfig['span-method']) {
        // 有自定义合并单元格时启用自定义index
        if (index === 0) this.spanIndex[0] = 0;
        this.spanIndex[0] = this.spanIndex[0] + 1;
        return (this.nativePaginConfig.page_no - 1) * this.nativePaginConfig.page_size + this.spanIndex[0];
      }
      return (this.nativePaginConfig.page_no - 1) * this.nativePaginConfig.page_size + index + 1;
    },
    handleCurrentChange(page) {
      this.nativePaginConfig.page_no = page;
      this.$emit('pageChange', this.nativePaginConfig);
      this.reSet = false;
      this.setData();
    },
    handlePageChange(pageSize) {
      this.nativePaginConfig.page_size = pageSize;
      this.nativePaginConfig.page_no = 1;
      this.$emit('pageChange', this.nativePaginConfig);
      this.reSet = false;
      this.setData();
    },
    handleInputChange(key, value, labelKey, labelValue) {
      this.formData[key] = value;
      if (labelKey) this.formData[labelKey] = labelValue;
    },
    clearSearchKey() {
      Object.keys(this.nativeSearchFormData).map(key => {
        this.nativeSearchFormData[key] = '';
        return key;
      });
      this.setData();
    },
    handleHeaderInputChange(key, value) {
      this.$store[key] = value;
      this.nativeSearchFormData[key] = value;
      this.nativePaginConfig.page_no = 1;
      this.setData();
    },
    getFormData() {
      return this.formData;
    },
    validateForm() {
      // 校验可编辑表格是否可提交
      const value = this.formData[this.navtiveTableHeader[this.editIndex].value];
      const { pattern } = this.navtiveTableHeader[this.editIndex].editOptions;
      if (pattern) {
        return pattern.test(value);
      }
      return true;
    },
    editRow(item, row, index, e) {
      e.stopPropagation();
      this.$set(this.formData, item.value, row[item.value]);
      this.editRowObj = { ...row };
      const td = e.target.parentElement;
      const tdPosition = td.getBoundingClientRect();
      const parentPosition = this.$refs.lyTableContent.getBoundingClientRect();
      this.editStyle = {
        position: 'absolute',
        left: `${tdPosition.left - parentPosition.left}px`,
        top: `${tdPosition.top - parentPosition.top - 8}px`,
        width: `${td.offsetWidth + 10}px`
      };
      this.editIndex = index;
      this.editItem = { ...item };
      if (item.editOptions.type === 'status') this.nativeStatusAction();
    },
    async saveEdit() {
      const saveAction = this.navtiveTableHeader[this.editIndex].editOptions.saveAction || this.saveAction;
      if (saveAction) {
        if (this.validateForm()) {
          const res = await saveAction({
            id: this.editRowObj.id,
            methold: 'put',
            params: this.formData
          });
          if (res) {
            this.setData();
            this.$message.success(res.msg || '更新成功！');
          }
          this.editIndex = -1;
        } else {
          this.$message.warning('请填写正确的值！');
        }
      }
    },
    cancelEdit() {
      this.editIndex = -1;
    },
    getHeaderSlot(item) {
      const key = item.value;
      switch (item.headerSlot.type) {
        case 'select':
          return (
            <el-select
              placeholder={ item.name }
              size='mini'
              clearable
              popper-class='small-select'
              class='table-hd-select width-full'
              value={ this.nativeSearchFormData[key] }
              onInput={ value => this.handleHeaderInputChange(key, value) }
              { ...{ attrs: item.headerSlot.options } }
            >
              <el-option value={ -1 } label='全部'></el-option>
              { item.headerSlot.select.map(childItem => (
                <el-option { ...{ attrs: childItem } }></el-option>
              )) }
            </el-select>
          );
        default:
          return null;
      }
    },
    getEditFormItemByType() {
      if (this.editIndex < 0) return null;
      const obj = this.navtiveTableHeader[this.editIndex];
      const item = obj.editOptions;
      const key = obj.value;
      switch (item.type) {
        case 'text':
          return (
            <el-input
              type='text'
              value={ this.formData[key] }
              size={ 'small' }
              placeholder={ item.placeholder }
              { ...{ attrs: item.options } }
              onInput={ value => this.handleInputChange(key, value) }
            ></el-input>
          );
        case 'date':
          return (
            <el-date-picker
              value={ this.formData[key] }
              placeholder={ item.placeholder }
              onInput={ value => this.handleInputChange(key, value) }
              { ...{ attrs: item.options } }
            ></el-date-picker>
          );
        case 'select':
          return (
            <el-select
              placeholder={ item.placeholder }
              value={ this.formData[key] }
              onInput={ value => this.handleInputChange(key, value) }
              { ...{ attrs: item.options } }
            >
              { item.options.select.map(childItem => (
                <el-option { ...{ attrs: childItem } }></el-option>
              )) }
            </el-select>
          );
        case 'status':
          return (
            <el-dropdown class='status-action' trigger='click' onCommand={ this.nativeStatusAction }>
              <span class='el-dropdown-link' class={ this.editRowObj.activate_status ? 'blue' : 'red' }>
                { this.editRowObj.activate_status ? <span class='blue'>已启用</span> : <span class='red'>已禁用</span> }
                <i class='el-icon-arrow-down el-icon--right'></i>
              </span>
              <el-dropdown-menu slot='dropdown'>
                <el-dropdown-item>
                  { this.editRowObj.activate_status ? <span class='red'>禁用</span> : <span class='blue'>启用</span> }
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          );

        case 'slot':
          return this.$scopedSlots[key]({ item, formData: this.formData });
        default:
          return null;
      }
    },
    resetFields() {
      // 多选表格清空选择框
      this.$refs.lyTable.clearSelection();
    },
    // 启用/禁用
    async nativeStatusAction() {
      const row = { ...this.editRowObj };
      try {
        let res = null;
        const status = await this.$confirm(`确认${row.activate_status ? '禁用' : '启用'}`);
        if (status === 'confirm') {
          if (row.activate_status) {
            res = await this.statusAction[1](row);
          } else {
            res = await this.statusAction[0](row);
          }
          if (res) {
            this.$store.dispatch('msg/showMsg', res.msg || '更新成功！');
            this.setData();
            this.cancelEdit();
          }
        }
      } catch (e) {
        this.cancelEdit();
      }
    }
  },
  render() {
    return (
      <div class='ly-table' ref='lyTableContent' id={ this.id } v-loading={ this.loading }>
        <el-table
          ref={ 'lyTable' }
          { ...{
            attrs: this.nativeTableConfig
          } }
          { ...{ on: this.nativeTableConfig.action } }
        >
          { this.navtiveTableHeader.map((item, index) => {
            let align = '';
            if (this.tableConfig) align = this.tableConfig.align || 'left';
            if (item.option && item.option.align) {
              ({ align } = item.option);
            }
            if (item.name) {
              if (this.isShowOnly && item.value === 'action') {
                // 仅展示的table不展示操作列
                return null;
              }
              return (
                !item.isHide && (
                  <el-table-column
                    label={ item.name }
                    prop={ item.value }
                    class-name={ item.value === 'action' ? 'action-row' : '' }
                    key={ `${item.value}${index}` }
                    { ...{ attrs: item.option } }
                    align={ align }
                    { ...{
                      scopedSlots: {
                        default: ({ row }) => {
                          // fee_level容错
                          const rowTmp = { ...row };
                          if (rowTmp.fee_level === null) rowTmp.fee_level = { org_full_name: '' };
                          // 默认value_label为value对应的key值，但有slot则slot为准
                          const label = row[`${item.value}_label`] || row[item.value];
                          let rowItem = this.$scopedSlots[item.value] ? this.$scopedSlots[item.value](rowTmp) : label;
                          rowItem = rowItem === null || rowItem === '' || rowItem === undefined ? '一' : rowItem;
                          // 可编辑
                          if (item.editOptions) {
                            if (item.editOptions.type === 'status') {
                              // 判断操作权限
                              if (item.editOptions.hasPermission && !this.hasPermission(item.editOptions.hasPermission)) {
                                return ('一');
                              }
                              return (
                                <div onClick={ e => this.editRow(item, row, index, e) }>
                                  { row[item.value] ? (
                                    <span class='sta-green'>已启用</span>
                                  ) : (
                                    <span class='sta-red'>已禁用</span>
                                  ) }
                                  <i class='el-icon-edit edit-row'></i>
                                </div>
                              );
                            }
                            return (
                              <div>
                                { rowItem }
                                <i class='el-icon-edit edit-row' onClick={ e => this.editRow(item, row, index, e) }></i>
                              </div>
                            );
                          }
                          // 是or否特殊处理
                          if (rowItem === '是') {
                            rowItem = (
                              <el-tag size='mini' effect='plain' type='success'>
                                { rowItem }
                              </el-tag>
                            );
                          }

                          if (rowItem === '否') {
                            rowItem = (
                              <el-tag size='mini' effect='plain' type='danger'>
                                { rowItem }
                              </el-tag>
                            );
                          }

                          return rowItem;
                        },
                        header: scope => {
                          // header的slot名称为 `header_${item.value}`，此种格式的slot自动注入到header中
                          if (this.$scopedSlots[`header_${item.value}`]) {
                            return this.$scopedSlots[`header_${item.value}`](scope.row);
                          }
                          // header slot配置项
                          if (item.headerSlot) {
                            if (!(item.value in this.nativeSearchFormData)) {
                              this.$set(this.nativeSearchFormData, item.value, '');
                            }
                            return this.getHeaderSlot(item);
                          }
                          if (item.sort) {
                            // 暂时不实现
                            return (
                              <div>
                                { item.name }
                                <i class='el-icon-arrow-down sort'></i>
                              </div>
                            );
                          }
                          return item.name;
                        }
                      }
                    } }
                  />
                )
              );
            }
            // 特殊列（index或selection等）
            const { option } = item;
            if (this.nativePaginConfig.total > 10000 && option.type === 'index') option.width = option.width || 66;
            if (this.nativePaginConfig.total > 100000 && option.type === 'index') option.width = option.width || 72;
            return (
              <el-table-column
                index={ this.indexMethod }
                class-name={ option.type === 'index' ? 'ly-table-column-index' : '' }
                { ...{ attrs: option } }
              />
            );
          }) }
        </el-table>
        { !this.nativePaginConfig.isHide && (
          <el-pagination
            page-sizes={ [this.pageSize, this.pageSize * 2, this.pageSize * 3, this.pageSize * 5] }
            class={ 'ly-pagination' }
            onSize-change={ this.handlePageChange }
            onCurrent-change={ this.handleCurrentChange }
            layout='prev, pager, next, -> ,sizes, total'
            { ...{
              attrs: {
                ...this.nativePaginConfig,
                currentPage: this.nativePaginConfig.page_no,
                pageSize: this.nativePaginConfig.page_size
              }
            } }
          />
        ) }
        <div
          style={ this.editStyle }
          class={ this.editIndex === -1 ? 'none' : 'edit-content' }
          onClick={ e => e.stopPropagation() }
        >
          { this.getEditFormItemByType() }
          { this.editIndex >= 0 && this.editItem.editOptions.type !== 'status' && (
            <div class='action'>
              <i class='el-icon-check ok' onClick={ this.saveEdit }></i>
              <i class='el-icon-close cancel' onClick={ this.cancelEdit }></i>
            </div>
          ) }
        </div>
      </div>
    );
  }
};
</script>

<style lang='less'>
.ly-table {
  position: relative;

  .cell,
  .el-dropdown {
    font-size: 12px;
    line-height: 18px;
  }

  .el-table__body-wrapper {
    overflow: auto;
  }

  .ly-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .edit-row {
    color: @main-blue;
    cursor: pointer;
    padding-left: 5px;
  }

  .edit-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 3px 0;
    min-height: 40px;

    i {
      cursor: pointer;
    }

    .ok {
      color: @main-blue;
    }

    .cancel {
      color: @danger;
    }
  }

  .status-action {
    font-size: 14px;
    cursor: pointer;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: inherit;
  }

  .ly-table-column-index > .cell > div {
    white-space: nowrap;
  }

  .el-table__row td:not(.action-row) {
    .el-button--mini,
    .el-button--small {
      font-size: 12px;
    }
  }

  .row-blue,
  .row-yellow,
  .row-red {
    display: inline-block;
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .row-blue {
    background: #1a80ea;
    color: #fff;
  }

  .row-yellow {
    background: #e6a23c;
    color: #fff;
  }

  .row-red {
    background: red;
    color: #fff;
  }

  .el-table thead th {
    background: #ededed;

    div {
      line-height: 1;
    }
  }

  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #e8e8e8;
  }

  .sta-green {
    color: #61ad66;
    border: 1px solid #61ad66;
    border-radius: 10px;
    padding: 1px 10px;
  }

  .sta-red {
    color: #f85e5e;
    border: 1px solid #f85e5e;
    border-radius: 10px;
    padding: 1px 10px;
  }
}
</style>
